import React, { useEffect, useState } from 'react';

export function ReadingProgressBar({
  height = 3,
  color = '#6d3aec',
  trackColor = 'transparent',
  zIndex = 9999,
}) {
  const [progress, setProgress] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (window.location.pathname !== '/') {
      setShow(true);
    }

    let ticking = false;

    const calc = () => {
      const doc = document.documentElement;
      const scrollTop = window.pageYOffset || doc.scrollTop || 0;
      const scrollHeight = doc.scrollHeight || 0;
      const clientHeight = window.innerHeight || doc.clientHeight || 0;
      const max = Math.max(scrollHeight - clientHeight, 1);
      const pct = Math.min(Math.max((scrollTop / max) * 100, 0), 100);
      setProgress(pct);
    };

    const onScrollOrResize = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        calc();
        ticking = false;
      });
    };

    calc();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    return () => {
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
    };
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height,
        backgroundColor: trackColor,
        zIndex,
      }}
      aria-hidden>
      <div
        role='progressbar'
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(progress)}
        style={{
          height: '100%',
          width: `${progress}%`,
          backgroundColor: color,
          transition: 'width 80ms linear',
          willChange: 'width',
        }}
      />
    </div>
  );
}
